import { render, staticRenderFns } from "./ContainerEdit.vue?vue&type=template&id=b33db39a&"
import script from "./ContainerEdit.vue?vue&type=script&lang=js&"
export * from "./ContainerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports